
import React from "react";
import Header from "@/components/Header";
import { Helmet } from "react-helmet-async";
import { useIsMobile } from "@/hooks/use-mobile";

interface CalculatorPageProps {
  title: string;
  mobileTitle: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  children: React.ReactNode;
  footerText: string;
  showTitle?: boolean;
  calculatorTitle?: string;
  calculatorDescription?: string;
}

const CalculatorPage = ({
  title,
  mobileTitle,
  description,
  keywords,
  canonicalUrl,
  children,
  footerText,
  showTitle = true,
  calculatorTitle,
  calculatorDescription
}: CalculatorPageProps) => {
  const isMobile = useIsMobile();
  const pageName = isMobile ? mobileTitle : title;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      
      <Header pageName={pageName} useBackButton={true} />
      
      <main className="flex-1 flex flex-col items-center justify-start px-4 py-8">
        <div className="w-full max-w-md">
          {showTitle && (
            <div className="text-center mb-6">
              <h1 className="text-2xl font-bold text-foreground mb-2">
                {calculatorTitle || "Flow Ratio Calculator"}
              </h1>
              <p className="text-muted-foreground text-sm">
                {calculatorDescription || "Calibrate your flow ratio for optimal 3D printing results"}
              </p>
            </div>
          )}
          
          <div className="bg-surface rounded-2xl shadow-lg border border-border/50 p-6">
            {children}
          </div>
        </div>
      </main>
      
      <footer className="bg-surface/80 backdrop-blur-sm border-t border-border/30 py-4 mt-8">
        <div className="container max-w-md mx-auto px-4">
          <p className="text-sm text-center text-muted-foreground">
            {footerText}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CalculatorPage;
